export enum GraphType {
  MONTHLY_END_BALANCE = 'MONTHLY_END_BALANCE',
  MONTHLY_ESTIMATED_COST = 'MONTHLY_ESTIMATED_COST',
}
